import { render, staticRenderFns } from "./publishShortVideos.vue?vue&type=template&id=731c3217&scoped=true&"
import script from "./publishShortVideos.vue?vue&type=script&lang=js&"
export * from "./publishShortVideos.vue?vue&type=script&lang=js&"
import style0 from "./publishShortVideos.vue?vue&type=style&index=0&id=731c3217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731c3217",
  null
  
)

component.options.__file = "publishShortVideos.vue"
export default component.exports